import React, { Component } from 'react';
import EmailStep from './steps/EmailStep';
import InterestStep from './steps/InterestStep';
import ConfirmStep from './steps/ConfirmStep';
import gtmPusher from '../../../../utils/gtmPusher';
import client from '../../../../utils/client';

import './form.scss';

class SignupContainer extends Component {
  constructor(props) {
    super(props);
    this.handleData = this.handleData.bind(this);
    this.convertToJSON = this.convertToJSON.bind(this);
    this.state = {
      stepNumber: 1,
      email: '',
      name: '',
      interestData: [],
      device: window.innerWidth > 768 ? 'desktop' : 'mobile',
      source: props.signupSource,
      tag: props.tag || '',
    };
  }

  handleData(data) {
    switch (this.state.stepNumber) {
      case 1:
        this.setState({
          email: data.email,
          name: data.name,
          stepNumber: 2,
        });
        break;
      case 2:
        this.setState({
          interestData: data,
          stepNumber: 3,
        });
        window.setTimeout(() => {
          this.convertToJSON();
        }, 100);
        break;
      default:
        break;
    }
  }

  convertToJSON() {
    let updatedName = '';
    if (this.state.name.trim().includes(' ')) {
      updatedName = this.state.name;
    } else {
      updatedName = `${this.state.name.trim()} ${this.state.name.trim()}`;
    }
    const data = {
      email: this.state.email,
      name: updatedName,
      device: this.state.device,
      source: this.state.source,
      interest_categories: this.state.interestData,
      member_info: {
        campaign_id: window.campaign_data.campaign_id,
      },
    };

    if (this.state.tag) {
      data.tag = this.state.tag;
    }

    client.post('/checkout/subscribe_for_news/', data)
      .then(() => {
        const gaObj = {
          event: 'newsletterSubscription',
          eventCategory: 'newsletter',
          eventAction: data.interest_categories[0].types.join(','),
          eventLabel: 'success',
          eventValue: 0,
          eventNonInteraction: false,
        };
        gtmPusher(gaObj, null);
      })
      .catch(() => {
        const gaObj = {
          event: 'newsletterSubscription',
          eventCategory: 'newsletter',
          eventAction: data.interest_categories[0].types.join(','),
          eventLabel: 'error',
          eventValue: 0,
          eventNonInteraction: false,
        };
        gtmPusher(gaObj, null);
      });
  }

  render() {
    return (
      <div className="signupWrapper">
        <div
          className="background"
          style={{
            backgroundColor: this.props.backgroundColor,
            opacity: this.props.opacity,
          }}
        />
        {this.state.stepNumber === 1 ? (
          <EmailStep
            onNextClick={this.handleData}
            titleColor={this.props.titleColor}
            textColor={this.props.textColor}
            ctaBackgroundColor={this.props.ctaBackgroundColor}
            ctaTextColor={this.props.ctaTextColor}
            ctaBorderColor={this.props.ctaBorderColor}
            content={this.props.content}
            campaignType={this.props.campaignType}
            roundTheCorners={this.props.roundTheCorners}
          />
        ) : null}
        {this.state.stepNumber === 2 ? (
          <InterestStep
            onNextClick={this.handleData}
            titleColor={this.props.titleColor}
            textColor={this.props.textColor}
            ctaBackgroundColor={this.props.ctaBackgroundColor}
            ctaTextColor={this.props.ctaTextColor}
            ctaBorderColor={this.props.ctaBorderColor}
            roundTheCorners={this.props.roundTheCorners}
          />
        ) : null}
        {this.state.stepNumber === 3 ? (
          <ConfirmStep
            onNextClick={this.handleData}
            titleColor={this.props.titleColor}
            textColor={this.props.textColor}
          />
        ) : null}
      </div>
    );
  }
}

export default SignupContainer;
